/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFFindingLevel = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Info: 'info'
} as const;
export type CRSFFindingLevel = typeof CRSFFindingLevel[keyof typeof CRSFFindingLevel];


export function CRSFFindingLevelFromJSON(json: any): CRSFFindingLevel {
    return CRSFFindingLevelFromJSONTyped(json, false);
}

export function CRSFFindingLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFFindingLevel {
    return json as CRSFFindingLevel;
}

export function CRSFFindingLevelToJSON(value?: CRSFFindingLevel | null): any {
    return value as any;
}

